var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cl from 'clsx';
import React, { forwardRef } from 'react';
const Ingress = forwardRef((_a, ref) => {
    var { className, spacing, as: Component = 'p' } = _a, rest = __rest(_a, ["className", "spacing", "as"]);
    return (React.createElement(Component, Object.assign({}, rest, { ref: ref, className: cl(className, 'cds-ingress', {
            'cds-typo--spacing': !!spacing
        }) })));
});
Ingress.displayName = 'Ingress';
export default Ingress;
